import React, {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getOverlayVisibilityState} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {OverlayType} from 'modules/overlay/types'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

/**
 * Bottom sheet used to display copy explaining split bookings
 */
export const SplitBookingInfoBottomSheet: React.FC = () => {
  const dispatch = useDispatch()

  const isOpen = useSelector(state =>
    getOverlayVisibilityState(state, OverlayType.SplitBookingInfoBottomSheet)
  )

  const onClose = useCallback(() => {
    dispatch(hideOverlay())
  }, [dispatch])

  return (
    <BottomSheet
      isOpen={isOpen}
      navBarProps={{
        centerContent: (
          <FormattedMessageWrapper
            id="switchRoomsAndSave"
            defaultMessage="Switch rooms and save"
          />
        )
      }}
      onClose={onClose}
    >
      <Box paddingTop="s300" paddingBottom="s300">
        <Box display="flex" flexDirection="column" gap="s500">
          <Text variant="bodyM">
            <FormattedMessageWrapper
              id="splitBooking.roomSwitchRequiredTooltipContent"
              defaultMessage="The cheapest way to stay here is to split your stay across two separate bookings."
            />
          </Text>
          <Button variant="tertiary" size="xl" onClick={onClose} fullWidth>
            <FormattedMessageWrapper
              id="gotItButton"
              defaultMessage="Ok, got it"
            />
          </Button>
        </Box>
      </Box>
    </BottomSheet>
  )
}
